import { render, staticRenderFns } from "./AdminView2.vue?vue&type=template&id=76d7e68f&scoped=true&"
import script from "./AdminView2.vue?vue&type=script&lang=js&"
export * from "./AdminView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d7e68f",
  null
  
)

export default component.exports